<template>
  <div class="activity-preview-page-template">
    <OnBoardingActivity @load="loading" @loaded="loaded" :aid="aid" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OnBoardingActivity from "@/components/OnBoardingActivity";

export default {
  name: "ActivityPreviewPage",
  components: {
    OnBoardingActivity
  },
  props: {
    aid: {
      type: String,
      required: true
    }
  },
  methods: {
    loaded() {
      this.$emit("onLoaded");
    },
    loading() {
      this.$emit("onLoading");
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-preview-page-template {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>